import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CirclePlay, Database, Video, Pointer, PenTool, Newspaper, Volleyball, ArrowRight } from 'lucide-react';
import { Project } from '../data/projectsData';
import '../styles/ProjectCard.css';

interface ProjectCardProps {
  project: Project;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/work/${project.slug}`);
  };

  const categoryIcons = {
    automation: CirclePlay,
    data: Database,
    ar: Video,
    touch: Pointer,
    branding: PenTool,
    news: Newspaper,
    sports: Volleyball
  };

  return (
    <div className="project-card" onClick={handleCardClick}>
      <div className="project-image">
        <img src={project.image || '/default.png'} alt={project.title} />
        <div className="project-overlay">
          <div className="project-links">
            {project.githubUrl && (
              <a 
                href={project.githubUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="project-link"
                onClick={(e) => e.stopPropagation()}
              >
                GitHub
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="project-content">
        {project.year && (
          <div className="project-year-badge">
            {project.year}
          </div>
        )}
        {project.subtitle && (
          <div className="project-subtitle">{project.subtitle}</div>
        )}
        <h3>{project.title}</h3>
        <p>{project.description}</p>
        <div className="project-footer">
          <div className="project-categories">
            {project.categories.map((category, index) => {
              const IconComponent = categoryIcons[category];
              return IconComponent ? (
                <div 
                  key={index} 
                  className="category-icon-wrapper"
                >
                  <IconComponent 
                    size={18} 
                    className="category-icon" 
                  />
                  <div className="tooltip-balloon">
                    {category.toUpperCase()}
                  </div>
                </div>
              ) : null;
            })}
          </div>
          <div className="read-more-overlay">
            <div className="read-more-message">
              <span>Read more</span>
              <ArrowRight size={14} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;